import { AdminPermissions } from '@order-management/roles';
import { useCallback } from 'react';
import { Element, Icon } from 'react-bulma-components';
import { FaFileInvoice } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import AdminToolsDropdown from '../../ui/admin-tools-dropdown/admin-tools-dropdown';
import Button from '../../ui/button/button';
import CheckPermissions from '../check-permissions/check-permissions';

export function AdminToolbar() {
  const navigate = useNavigate();

  const navigateToWorkOrders = useCallback(() => {
    navigate('/work-orders');
  }, [navigate]);

  return (
    <Element display="flex" flexDirection="row" className="gap-4">
      <Button
        className="is-borderless hoverable-primary-dark"
        color="transparent"
        onClick={navigateToWorkOrders}
      >
        <Icon color="primary-dark">
          <FaFileInvoice />
        </Icon>
        <span className="is-underlined has-text-primary-dark">Work orders</span>
      </Button>

      <CheckPermissions permissions={AdminPermissions.ADMIN_TOOLS_ACCESS}>
        <CheckPermissions.Render>
          <AdminToolsDropdown />
        </CheckPermissions.Render>
      </CheckPermissions>
    </Element>
  );
}

export default AdminToolbar;
